module.exports = __webpack_public_path__ + "img/full1-min.0b59d88a.png";